// Configuration for AMS Admin App - Unified Backend
// Single backend API with all services consolidated
// Updated: 2025-07-27

import { ProductType } from "./types/api";

// Environment-based API configuration
const getApiBaseUrl = () => {
  if (import.meta.env.MODE === 'production') {
    return import.meta.env.VITE_API_URL || 'https://ams-admin-v2-server.amajormusic.co.uk';
  }
  return 'http://localhost:3000';
};

const API_BASE_URL = getApiBaseUrl();

// Unified API endpoints - all services now under single backend
export const INV_API = `${API_BASE_URL}/products/`;
export const LOCS_API = `${API_BASE_URL}/locations/`;
export const STOCKTAKE_API = `${API_BASE_URL}/stocktake/`;

export const PURCHASING_API = `${API_BASE_URL}/purchasing/`;
export const SUPPLIERS_API = `${API_BASE_URL}/supplier/`;
export const QUOTES_API = `${API_BASE_URL}/quotes/`;

export const NEXT_NUMBER_API = `${API_BASE_URL}/next-number/`;
export const AUDIT_EVENT_API = `${API_BASE_URL}/audit-event/`;
export const CUSTOM_SALE_API = `${API_BASE_URL}/custom-sale/`;

// Environment-based Shopify URL configuration
const getShopifyUrl = () => {
  if (import.meta.env.MODE === 'production') {
    return import.meta.env.VITE_SHOPIFY_URL || 'https://amajormusic.co.uk';
  }
  return 'https://a-major-music-test.myshopify.com';
};

export const SHOPIFY_URL = getShopifyUrl();

export const NOTIFICATION_TIMEOUT_MS = 10000;
export const NN_PO_KEY = "po.number";
export const NN_BOOK_KEY = "sku.book";
export const NN_ACCESSORY_KEY = "sku.accessory";
export const NN_GIFT_KEY = "sku.gift";
export const NN_INSTRUMENT_KEY = "sku.instrument";
export const NN_OTHER_KEY = "sku.other";

export const ProductTypePrefix = {
    [ProductType.BOOK]: "BOK",
    [ProductType.GIFT]: "GFT",
    [ProductType.ACCESSORY]: "ACC",
    [ProductType.INSTRUMENT]: "INS",
    [ProductType.OTHER]: "OTH",
  };  

export const MISSING_PRODUCT_IMAGE_URL = "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"

export const VAT_RATE = 20;

// Note: API_KEY is deprecated - we now use Auth0 JWT tokens for authentication
